import React from 'react'
import { Timeline } from 'antd'
import type { Order } from '../types/order.types'
import { formatIST } from '../../../shared/utils/formatters'

interface OrderTimelineProps {
    order: Order
}

export const OrderTimeline: React.FC<OrderTimelineProps> = ({ order }) => {
    return (
        <Timeline
            items={[
                {
                    color: 'green',
                    children: (
                        <>
                            <p><strong>Order Placed</strong></p>
                            <p>{formatIST(order.created_at)}</p>
                        </>
                    ),
                },
                {
                    color: order.status !== 'pending' ? 'green' : 'gray',
                    children: (
                        <>
                            <p><strong>Order Confirmed</strong></p>
                            <p>{order.status !== 'pending' ? 'Confirmed' : 'Pending'}</p>
                        </>
                    ),
                },
                {
                    color: order.status === 'shipped' || order.status === 'delivered' ? 'green' : 'gray',
                    children: (
                        <>
                            <p><strong>Order Shipped</strong></p>
                            <p>{order.status === 'shipped' || order.status === 'delivered' ? 'Shipped' : 'Pending'}</p>
                        </>
                    ),
                },
                {
                    color: order.status === 'delivered' ? 'green' : 'gray',
                    children: (
                        <>
                            <p><strong>Order Delivered</strong></p>
                            <p>{order.status === 'delivered' ? 'Delivered' : 'Pending'}</p>
                        </>
                    ),
                },
            ]}
        />
    )
}
